
jQuery.fn.umtGform = function() {
	return this.each( function() {
		const element = jQuery( this );

		const utm_source = getParameterByName( 'utm_source' );
		const utm_medium = getParameterByName( 'utm_medium' );
		const utm_campaign = getParameterByName( 'utm_campaign' );
		const utm_term = getParameterByName( 'utm_term' );
		const utm_content = getParameterByName( 'utm_content' );
		const utm_id = getParameterByName( 'utm_id' );
		const clear = getParameterByName( 'clear' );

		let getFirstUMT = getValue( 'firstUTM' );

		if ( utm_source || utm_medium || utm_campaign || utm_term || utm_content || utm_id ) {
			const firstUTM = {
				utm_source, utm_medium, utm_campaign, utm_term, utm_content, utm_id,
			};
			const lastUTM = {
				utm_source, utm_medium, utm_campaign, utm_term, utm_content, utm_id,
			};

			if ( getFirstUMT === null ) {
				storeValueWithExpiration( 'firstUTM', firstUTM, 30000 );
			}
			storeValueWithExpiration( 'lastUTM', lastUTM, 30000 );
		}
		const getLastUMT = getValue( 'lastUTM' );
		getFirstUMT = getValue( 'firstUTM' );
		// console.log( getLastUMT );

		if ( getLastUMT ) {
			jQuery( '.js-utm-source-last' ).find( 'input[type="text"]' ).val( ( getLastUMT.utm_source ) ? getLastUMT.utm_source : '' );
			jQuery( '.js-utm-medium-last' ).find( 'input[type="text"]' ).val( ( getLastUMT.utm_medium ) ? getLastUMT.utm_medium : '' );
			jQuery( '.js-utm-campaign-last' ).find( 'input[type="text"]' ).val( ( getLastUMT.utm_campaign ) ? getLastUMT.utm_campaign : '' );
			jQuery( '.js-utm-term-last' ).find( 'input[type="text"]' ).val( ( getLastUMT.utm_term ) ? getLastUMT.utm_term : '' );
			jQuery( '.js-utm-content-last' ).find( 'input[type="text"]' ).val( ( getLastUMT.utm_content ) ? getLastUMT.utm_content : '' );
			jQuery( '.js-utm-id-last' ).find( 'input[type="text"]' ).val( ( getLastUMT.utm_id ) ? getLastUMT.utm_id : '' );
		}
		console.log( getFirstUMT );
		if ( getFirstUMT ) {
			jQuery( '.js-utm-source-first' ).find( 'input[type="text"]' ).val( ( getFirstUMT.utm_source ) ? getFirstUMT.utm_source : '' );
			jQuery( '.js-utm-medium-first' ).find( 'input[type="text"]' ).val( ( getFirstUMT.utm_medium ) ? getFirstUMT.utm_medium : '' );
			jQuery( '.js-utm-campaign-first' ).find( 'input[type="text"]' ).val( ( getFirstUMT.utm_campaign ) ? getFirstUMT.utm_campaign : '' );
			jQuery( '.js-utm-term-first' ).find( 'input[type="text"]' ).val( ( getFirstUMT.utm_term ) ? getFirstUMT.utm_term : '' );
			jQuery( '.js-utm-content-first' ).find( 'input[type="text"]' ).val( ( getFirstUMT.utm_content ) ? getFirstUMT.utm_content : '' );
			jQuery( '.js-utm-id-first' ).find( 'input[type="text"]' ).val( ( getFirstUMT.utm_id ) ? getFirstUMT.utm_id : '' );
		}
		if ( clear === 'local-storage' ) {
			localStorage.removeItem( 'firstUTM' );
			localStorage.removeItem( 'lastUTM' );
		}
		function getParameterByName( name, url = window.location.href ) {
			name = name.replace( /[\[\]]/g, '\\$&' );
			const regex = new RegExp( '[?&]' + name + '(=([^&#]*)|&|#|$)' ),
				results = regex.exec( url );
			if ( ! results ) {
				return null;
			}
			if ( ! results[ 2 ] ) {
				return '';
			}
			return decodeURIComponent( results[ 2 ].replace( /\+/g, ' ' ) );
		}
		function storeValueWithExpiration( key, value, expirationMinutes ) {
			const now = new Date();
			const expiration = new Date( now.getTime() + expirationMinutes * 60000 );
			const item = {
				value,
				expiration: expiration.getTime(),
			};
			localStorage.setItem( key, JSON.stringify( item ) );
		}

		// Function to retrieve a value from localStorage and check its expiration
		function getValue( key ) {
			const item = localStorage.getItem( key );
			if ( item ) {
				const parsedItem = JSON.parse( item );
				const now = new Date().getTime();
				if ( now < parsedItem.expiration ) {
					return parsedItem.value;
				}
				localStorage.removeItem( key ); // Remove the expired item
			}
			return null; // Return null if item doesn't exist or has expired
		}
	} );
};
jQuery( document ).ready( function() {
	jQuery( 'body' ).umtGform();
	jQuery( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
		localStorage.removeItem( 'firstUTM' );
		localStorage.removeItem( 'lastUTM' );
	} );
} );
